
import { isEmpty, orderBy as orderByLoadash } from 'lodash';
import extractPositionFromName from './orderChecklist';

export const createThreeQuestion = (questionArray, typeOfData) => {
    if(isEmpty(questionArray)) return {};
    const groupArray = [];
    questionArray.forEach(question => {
        if(question.type === 'group') {
            question.questionArray = [];
            extractPositionFromName(question)
            groupArray.push(question) 
        }
    });

    const groupArrayOrdered = orderByLoadash(groupArray, ['position', 'name'], ['asc', 'asc']);

    questionArray.forEach(question => {
        if (question.type === 'question') {
            let index;
            if(typeOfData === 'groupPopulated') { // id populado
                extractPositionFromName(question)
                index = groupArrayOrdered.findIndex(ga => ga._id && question.groupId && ga._id === question.groupId._id);
            } else if(typeOfData === 'groupAsName') { //usado para popular um servico
                extractPositionFromName(question)
                index = groupArrayOrdered.findIndex(ga => ga.name === question.groupName);
            } else { // quando o id nao foi populado
                index = groupArrayOrdered.findIndex(ga => ga._id === question.groupId);
            }
            if(index > -1) {
                groupArrayOrdered[index].questionArray.push(question)
            }
        }
    });

    groupArrayOrdered.forEach(group => {
        let score = 0;
        let totalScore = 0;

        group.questionArray.forEach(question => {
            if (question.answer === 'NO') { score += 0; totalScore += question.weight; }
            else if (question.answer === 'YES') { score += question.weight; totalScore += question.weight; }
        })

        group.score = score;
        group.totalScore = totalScore;
    })

    return groupArrayOrdered;
}

